<template>
	<div>
		<!-- 副导航 -->
		<c-r-m-nav-cell
			ref="navcell" 
			:crm-type="crmType" 
			route-type="index"/>
		<div v-loading="loading" class="main-container">
			<c-r-m-list-head
				ref="listHead" 
				:crm-type="crmType" 
				:actiontype="actiontype"
				@on-handle="listHeadHandle"/>
			<filtrate-handle-view 
				class="filtrate-bar" 
				module-type="customer" 
				:show-quit="true" 
				:showProductSelect="true"
				@load="loading=false" 
				@change="searchClick" />
			<!-- 统计 -->
			<div class="content">
				<div class="table-content">
					<el-table 
						:data="list" 
						stripe 
						border 
						highlight-current-row
						style="width: 100%"
						:header-cell-style="{'background-color':'#f6faff'}" >
						<el-table-column 
							v-for="(item, index) in fieldList" 
							:key="index" 
							:prop="item.field"
							:label="item.name" 
							align="center" 
							header-align="center" 
							show-overflow-tooltip />
					</el-table>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import base from '../mixins/base'
	import CRMNavCell from '@/components/table/new/CRMNavCell'
	import CRMListHead from '@/components/table/new/CRMListHead'
	import {
		crmCustomerStatistics,
		crmCustomerStatisticsType,
		crmCustomerStatisticsOrigin,
		crmCustomerStatisticsOriginType
	} from '@/api/customer/customer'
	export default {
		components: {
			CRMNavCell,
			CRMListHead
		},
		mixins: [base],
		data() {
			return {
				crmType:"customer",
				actiontype:0,
				defaultPage:0,
				loading: false,
				postParams: {}, // 筛选参数
				list: [],
				axisList: [],
				fieldList: [
					{field: 'username',name: '员工姓名'},
					{field: 'create_count',name: '创建客户数'},
					{field: 'done_count',name: '成交客户数'},
					{field: 'zixun_charge',name: '咨询收费'},
					{field: 'lawcase_charge',name: '案件收费'},
					{field: 'contract_charge',name: '顾问收费'},
					{field: 'total_charge',name: '收费总金额'},
					{field: 'no_charge_count',name: '面谈未收费'},
					{field: 'follow_count',name: '正在跟进'},
					{field: 'public_count',name: '公海池'},
					{field: 'lawcase_count',name: '案件'},
					{field: 'contract_count',name: '顾问'},
					{field: 'log_count',name: '更新日志数'}
				]
			}
		},
		methods: {
			searchClick(params) {
				this.postParams = params
				this.getRecordList()
			},

			/**
			 * 获取相关列表
			 */
			getRecordList(dataIndex) {
				this.list = []

				let params = {}

				if (typeof dataIndex !== 'undefined') {
					const dataItem = this.axisList[dataIndex]
					params.re_user_id = this.postParams.user_id
					params.structure_id = this.postParams.structure_id
					params.start_time = dataItem.start_time
					params.end_time = dataItem.end_time
				} else {
					params = this.postParams
				}

				this.loading = true
				let request
				
				if(this.defaultPage == 0){
					request = crmCustomerStatistics
				}else if(this.defaultPage == 1){
					request = crmCustomerStatisticsType
				}else if(this.defaultPage == 2){
					request = crmCustomerStatisticsOrigin
				}else if(this.defaultPage == 3){
					request = crmCustomerStatisticsOriginType
				}
				
				request(params)
					.then(res => {
						this.loading = false
						if(this.defaultPage == 3){
							this.fieldList = res.data.columns
							this.list = res.data.data
						}else{
							this.list = res.data
						}
						
						
					})
					.catch(() => {
						this.loading = false
					})
			},
			
			listHeadHandle(item){
				this.defaultPage = item
				this.list = []
				if(item == 1){
					this.fieldList =  [
						{field: 'customer_type',name: '案件类型'},
						{field: 'create_count',name: '创建客户数'},
						{field: 'done_count',name: '成交客户数'},
						{field: 'zixun_charge',name: '咨询收费'},
						{field: 'lawcase_charge',name: '案件收费'},
						{field: 'contract_charge',name: '顾问收费'},
						{field: 'total_charge',name: '收费总金额'},
						{field: 'no_charge_count',name: '面谈未收费'},
						{field: 'follow_count',name: '正在跟进'},
						{field: 'public_count',name: '公海池'},
						{field: 'lawcase_count',name: '案件'},
						{field: 'contract_count',name: '顾问'}
					]
				}else if(item == 2){
					this.fieldList = [
						{field: 'origin',name: '客户来源'},
						{field: 'create_count',name: '创建客户数'},
						{field: 'done_count',name: '成交客户数'},
						{field: 'zixun_charge',name: '咨询收费'},
						{field: 'lawcase_charge',name: '案件收费'},
						{field: 'contract_charge',name: '顾问收费'},
						{field: 'total_charge',name: '收费总金额'},
						{field: 'no_charge_count',name: '面谈未收费'},
						{field: 'follow_count',name: '正在跟进'},
						{field: 'public_count',name: '公海池'},
						{field: 'lawcase_count',name: '案件'},
						{field: 'contract_count',name: '顾问'}
					]
				}else if(item == 3){
					this.fieldList = []
				}else{
					this.fieldList = [
						{field: 'username',name: '员工姓名'},
						{field: 'create_count',name: '创建客户数'},
						{field: 'done_count',name: '成交客户数'},
						{field: 'zixun_charge',name: '咨询收费'},
						{field: 'lawcase_charge',name: '案件收费'},
						{field: 'contract_charge',name: '顾问收费'},
						{field: 'total_charge',name: '收费总金额'},
						{field: 'no_charge_count',name: '面谈未收费'},
						{field: 'follow_count',name: '正在跟进'},
						{field: 'public_count',name: '公海池'},
						{field: 'lawcase_count',name: '案件'},
						{field: 'contract_count',name: '顾问'},
						{field: 'log_count',name: '更新日志数'}
						
					]
				}
			}
			
		}
	}
</script>

<style scoped>
	.main-container {
		border: 1px solid #e6e6e6;
		border-radius: 2px;
		background-color: white;
		height: 100%;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		margin-top: 10px;
	}

	.filtrate-bar {
		background-color: white;
		padding: 15px 20px 5px 20px;
		margin-right: 15px;
	}

	.content {
		height: calc(100% - 54px);
		overflow-y: auto;
		padding: 10px 0;
	}

	.table-content {
		padding: 0 20px 0px 20px;
	}
	/deep/ .el-table{
		font-size: 13px;
	}
	/deep/ .el-table__header-wrapper th {
		position: sticky;
		top: 0;
		z-index: 1;
	}
	.heise{
		color:#333 !important;
	}
	/deep/ .el-tag{
		/* color:#333 !important; */
		/* width: 85px !important; */
		overflow: hidden;
		text-align: center;
		padding:0 !important
	}
	/deep/ .el-table .el-table__cell {
	    padding: 3px 0 !important;
	}
</style>